export default {"src":"/_next/static/media/backgroundOpenedDocEtDent75.ec81c8b5.svg","height":167,"width":464,"blurWidth":0,"blurHeight":0};